import React, { Component } from 'react';
import styled from 'styled-components';
export const TimeRemaining = styled.div `
  font-size: ${(props) => props.theme.fontXLarge};
  line-height: 25px;
  font-weight: ${(props) => props.theme.extrabold};
  color: ${(props) => props.theme.fontColor};
`;
export default class Timer extends Component {
    constructor(props) {
        super(props);
        this.timer = 0;
        this.componentDidMount = () => {
            this.startTimer();
        };
        this.startTimer = () => {
            if (this.timer === 0) {
                this.timer = window['setInterval'](this.countDown, 1000);
            }
        };
        this.countDown = () => {
            this.setState(({ seconds }) => ({
                seconds: seconds - 1,
            }));
            if (this.state.seconds === 0 && this.timer) {
                clearInterval(this.timer);
                this.props.onFinish();
            }
        };
        this.state = {
            seconds: props.countDown,
        };
    }
    componentDidUpdate(prevProps) {
        const { countDown } = this.props;
        if (countDown !== prevProps.countDown) {
            this.setState(({ seconds }) => ({
                seconds: countDown,
            }));
            this.startTimer();
        }
    }
    render() {
        const { className } = this.props;
        const { seconds } = this.state;
        const newMinutes = Math.floor(seconds / 60);
        var newSeconds = seconds - newMinutes * 60;
        return (React.createElement(TimeRemaining, { className: className || '' },
            newMinutes != 0 && React.createElement(React.Fragment, null,
                newMinutes,
                "m"),
            " ",
            newSeconds,
            "s"));
    }
}
